import { render, staticRenderFns } from "./my-msg.vue?vue&type=template&id=3869a3ea&scoped=true"
import script from "./my-msg.vue?vue&type=script&lang=js"
export * from "./my-msg.vue?vue&type=script&lang=js"
import style0 from "./my-msg.vue?vue&type=style&index=0&id=3869a3ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3869a3ea",
  null
  
)

export default component.exports